import { ResponseSizePKModel } from "./responseSizePKModel";

export class ResponseSizeModel {

    cEUSizesPK: ResponseSizePKModel;
    descrp: string;
    nuevo: boolean;

    constructor() { }
}